export default __webpack_public_path__ + "10ad985a07926030c16eb56a7f25c6c8.png";